module.exports = __webpack_public_path__ + "images/botdcfd1955f95a9d0ce4474ba1674abf10.svg";